import { hasContentInHTMLTags } from 'src/app/common/function';
import { ArticleBlock } from '../../../../models/article';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, ElementRef, OnChanges } from '@angular/core';
import { nodes as basicNodes, marks, Toolbar, Editor } from 'ngx-editor';
import { DOMOutputSpec, Schema, NodeSpec } from 'prosemirror-model';
import { EditorState, Plugin, PluginKey, Transaction } from 'prosemirror-state';
import { setBlockType } from 'prosemirror-commands';
import { EditorView } from 'prosemirror-view';
import { isNodeActive } from 'ngx-editor/helpers';

@Component({
  selector: 'app-article-quote',
  templateUrl: './article-quote.component.html',
  styleUrls: ['./article-quote.component.scss']
})
export class ArticleQuoteComponent implements OnInit, OnDestroy, OnChanges {

  @Output() blockElementChange = new EventEmitter<ArticleBlock>();

  @Input() blockElement: ArticleBlock;

  quoteStyle: NodeSpec = {
    content: 'text*',
    marks: '',
    group: 'block',
    code: false,
    defining: true,
    isolating: true,
    toDOM() { return ["p", { class: "quote-text" }, 0] },
    parseDOM: [{ tag: "p.quote-text", priority: 60 }]
  };

  nodes = Object.assign({}, basicNodes, {
    quote: this.quoteStyle,
    paragraph: basicNodes.paragraph
  });

  schema = new Schema({
    nodes: this.nodes,
    marks,
    topNode: 'quote'
  });

  editor: Editor;
  toolbar: Toolbar = [];

  constructor(private renderer: Renderer2, private el: ElementRef) { }

  ngOnInit(): void {
    this.editor = new Editor({
      schema: this.schema,
    });
  }

  ngOnChanges(): void {
    setTimeout(() => {
      if (this.blockElement?.isActiveForEdit) {
        const editorElement = this.el.nativeElement.querySelector('.ProseMirror.NgxEditor__Content');
        this.renderer.setAttribute(editorElement, 'autofocus', 'true');
        editorElement.focus();

        const { state, dispatch } = this.editor.view;
        const currentType = state.selection.$from.parent.type;
        if (currentType !== this.schema.nodes['quote']) {
          setBlockType(this.schema.nodes['quote'])(state, dispatch);
        }
      }
    }, 700);
  }

  onChange(e: string) {
    this.blockElement.data = e;
    this.blockElementChange.emit(this.blockElement);
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }
}
